import { render, staticRenderFns } from "./task.vue?vue&type=template&id=058a7d6c&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=058a7d6c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a7d6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058a7d6c')) {
      api.createRecord('058a7d6c', component.options)
    } else {
      api.reload('058a7d6c', component.options)
    }
    module.hot.accept("./task.vue?vue&type=template&id=058a7d6c&scoped=true", function () {
      api.rerender('058a7d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qm/order/info/task.vue"
export default component.exports